import * as React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { push } from 'connected-react-router';
import './Dashboard.css';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ApplicationState } from '../../store';
import * as ConsoleStore from '../../store/Console';
import Reports from './Reports';
import Applications from './Dashboard/Applications';
import EmbeddedView from './EmbeddedView';
import Welcome from './Dashboard/Welcome';
import { Application } from '../../store/Console';

interface DashboardState {
    applications: Application[];
    dashboardComponent?: React.ReactNode;
}

type DashboardProps = {
} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class Dashboard extends React.Component<DashboardProps, DashboardState> {
    constructor(props: DashboardProps) {
        super(props);
        this.state = {
            applications: []
        };
        this.props.consoleActions.getApplications();            
    }

    public render() {
        return (
            <React.Fragment>
                <Switch>
                    <Route path={'/console/report'}>
                        <Reports />
                    </Route>
                    <Route path={'/console/embedded-view'}>
                        <EmbeddedView router={this.props.router} />
                    </Route>
                    <Route exact path={'/console/applications'}>
                        <Applications />
                    </Route>
                    <Route exact path={'/console'}>
                        <Welcome />
                    </Route>
                </Switch>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
